import { Form, Input, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

interface MultiLangInputProps {
  name: string;
  nameEn: string;
  label: string;
  placeholder?: string;
  placeholderEn?: string;
  rules?: any[];
  required?: boolean;
  type?: "input" | "textarea";
  rows?: number;
  maxLength?: number;
  className?: string;
  layout?: "horizontal" | "vertical";
  children?: ReactNode;
}

const MultiLangInput = ({
  name,
  nameEn,
  label,
  placeholder,
  placeholderEn,
  rules = [],
  required = false,
  type = "input",
  rows = 4,
  maxLength,
  className = "mb-0 flex-1 w-full",
  layout = "horizontal",
  children,
}: MultiLangInputProps) => {
  const { t } = useTranslation();

  const baseRules = required
    ? [
        {
          required: true,
          message: (
            <span className="text-xs sm:absolute relative mb-1 sm:mb-0 block">
              {t("formSetup.generalSetting.validName")}
            </span>
          ),
        },
        ...rules,
      ]
    : rules;

  const InputComponent = type === "textarea" ? Input.TextArea : Input;

  const tabItems = [
    {
      key: "vi",
      label: "Tiếng Việt",
      children: (
        <Form.Item
          name={name}
          layout={layout}
          className={className}
          rules={baseRules}
        >
          <InputComponent
            placeholder={placeholder}
            rows={type === "textarea" ? rows : undefined}
            maxLength={maxLength}
          />
        </Form.Item>
      ),
    },
    {
      key: "en",
      label: "English",
      children: (
        <Form.Item
          name={nameEn}
          layout={layout}
          className={className}
          rules={rules}
        >
          <InputComponent
            placeholder={placeholderEn || placeholder}
            rows={type === "textarea" ? rows : undefined}
            maxLength={maxLength}
          />
        </Form.Item>
      ),
    },
  ];

  if (layout === "vertical") {
    return (
      <div className="w-full">
        {label && (
          <span className="relative before:content-['*'] before:text-error before:mr-1 before:inline-block before:text-[14px] before:font-[SimSun] before:leading-none block text-left mb-2">
            {label}
          </span>
        )}
        <Tabs
          defaultActiveKey="vi"
          items={tabItems}
          size="small"
          className="w-full"
        />
        {children}
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row justify-between sm:justify-start md:items-start w-full gap-2 md:gap-6 lg:gap-8">
      <span className="relative before:content-['*'] before:text-error before:mr-1 before:inline-block before:text-[14px] before:font-[SimSun] before:leading-none block sm:w-32 text-left w-full">
        {label}
      </span>
      <div className="flex-1 w-full">
        <Tabs
          defaultActiveKey="vi"
          items={tabItems}
          size="small"
          className="w-full"
        />
        {children}
      </div>
    </div>
  );
};

export default MultiLangInput;
